import { HOLD_ONE_TIME_ACTION, RESOLVE_ONE_TIME_ACTION } from 'constants';

const initialState = {};

export default (state = initialState, action) => {
  switch(action.type){
    case HOLD_ONE_TIME_ACTION:
      return Object.assign({}, state, {
        [action.actionKey] : {
          promise: action.promise
        }
      });

    case RESOLVE_ONE_TIME_ACTION:
      return Object.assign({}, state, {
        [action.actionKey] : null
      });

    default:
      return state;
  }
};